import { QueryClient } from "@tanstack/react-query";

// TanStack Query client (DE-108 stack; server-state per the Memex FE baseline).
// Conservative defaults for a small internal tool.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
